<div class="row">
    <div class="col">
        <div class="blocks m-3 pt-0 px-0">


            <form [formGroup]="formBuilder">

                <!--Scelta tipo-->
                <div class="row pt-4 px-3">
                    <div class="col-12 m-3">
                        <label for="exampleFormControlInput1" class="form-label label-fw">Crea: </label>
                        <div class="form-check form-check-inline mx-3">
                            <input formControlName="type" name="type" class="form-check-input" type="radio"
                                id="field_type_prodotto" value="PRODOTTO" checked>
                            <label class="form-check-label" for="field_type_prodotto">Prodotto</label>
                        </div>
                        <div class="form-check form-check-inline mx-3">
                            <input formControlName="type" name="type" class="form-check-input" type="radio"
                                id="field_type_servizio" value="SERVIZIO">
                            <label class="form-check-label" for="field_type_servizio">Servizio</label>
                        </div>
                        <div class="form-check form-check-inline mx-3">
                            <input formControlName="type" name="type" class="form-check-input" type="radio"
                                id="field_type_smartphone" value="SMARTPHONE">
                            <label class="form-check-label" for="field_type_smartphone">Smartphone</label>
                        </div>
                    </div>
                </div>

                <!--main input-->
                <div class="row px-3">
                    <div class="col-12">
                        <div class="m-3">
                            <label for="field_serviceName" class="form-label label-fw">Nome *</label>
                            <input formControlName="serviceName" name="serviceName" type="text"
                                class="form-control form-fw " id="field_serviceName" placeholder="Service name">
                        </div>
                    </div>
                </div>

                <div class="row px-3">
                    <div class="col-12">
                        <div class="m-3">
                            <label for="field_serviceDescription" class="form-label label-fw">Descrizione</label>
                            <ckeditor #serviceDescription="ngModel" [(ngModel)]="serviceDescriptionValue"
                                [ngModelOptions]="{standalone: true}" name="serviceDescription" [config]="ckeConfig"
                                (ngModelChange)="change()" debounce="500">
                            </ckeditor>
                        </div>
                    </div>
                </div>
                <hr class="m-3">

                <!--Validità-->
                <div class="row px-3">
                    <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label for="exampleFormControlInput1" class="form-label label-fw">Giorno inizio</label>
                            <input type="date" formControlName="startDay" name="startDay"
                                class="form-control form-fw lh-base" id="exampleFormControlInput1">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label for="exampleFormControlInput1" class="form-label label-fw">Ora</label>
                            <input type="time" formControlName="startTime" name="startTime"
                                class="form-control form-fw lh-base" id="exampleFormControlInput1">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label for="exampleFormControlInput1" class="form-label label-fw">Giorno fine</label>
                            <input type="date" formControlName="expirationDay" name="expirationDay"
                                class="form-control form-fw lh-base" id="exampleFormControlInput1"
                                placeholder="gg/mm/aaaa">
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label for="exampleFormControlInput1" class="form-label label-fw">Ora</label>
                            <input type="time" formControlName="expirationTime" name="expirationTime"
                                class="form-control form-fw lh-base" id="exampleFormControlInput1">
                        </div>
                    </div>
                </div>
                <hr class="m-3">
                <!--    Scheda tecnica -->
                <div class="row px-3">
                    <div class="col-12">
                        <div class="m-3">
                            <label for="field_dataSheet" class="form-label label-fw">Scheda tecnica</label>
                            <ckeditor #dataSheet="ngModel" [(ngModel)]="dataSheetValue"
                                [ngModelOptions]="{standalone: true}" name="dataSheet" [config]="ckeConfig"
                                (ngModelChange)="change()" debounce="500">
                            </ckeditor>
                        </div>
                    </div>
                </div>

                <!--    Informazioni offerta -->
                <div class="row px-3">
                    <div class="col-12">
                        <div class="m-3">
                            <label for="field_offerInformation" class="form-label label-fw">Informazioni offerta</label>
                            <ckeditor #offerInformation="ngModel" [(ngModel)]="offerInformationValue"
                                [ngModelOptions]="{standalone: true}" name="offerInformation" [config]="ckeConfig"
                                (ngModelChange)="change()" debounce="500">
                            </ckeditor>
                        </div>
                    </div>
                </div>

                <!--    Note legali -->
                <div class="row px-3">
                    <div class="col-12">
                        <div class="m-3">
                            <label for="field_legalNotice" class="form-label label-fw">Note legali</label>
                            <ckeditor #legalNotice="ngModel" [(ngModel)]="legalNoticeValue"
                                [ngModelOptions]="{standalone: true}" name="legalNotice" [config]="ckeConfig"
                                (ngModelChange)="change()" debounce="500">
                            </ckeditor>
                        </div>
                    </div>
                </div>

                <!--Select-->
                <div class="row px-3 my-4">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label for="field_landingPageType" class="form-label label-fw">Type URL landing page
                            </label>
                            <select formControlName="landingPageType" name="landingPageType"
                                class="form-select select-wh" id="field_landingPageType">
                                <option value="">Nessuna</option>
                                <option value="PAGEID">PAGEID</option>
                                <option value="URL">URL</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="m-3">
                            <label for="field_landingPageService" class="form-label label-fw">URL landing page</label>
                            <input formControlName="landingPageService" name="landingPageService" type="text"
                                class="form-control form-fw " id="field_landingPageService"
                                placeholder="URL landing page">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="mx-3">
                            <label for="field_urlClickAndCollectType" class="form-label label-fw">Url Prenota e ritira
                            </label>
                            <select 
                                    (change)="changeUrlClickAndCollectType()"
                                    formControlName="urlClickAndCollectType" 
                                    name="urlClickAndCollectType"
                                    class="form-select select-wh" 
                                    id="field_urlClickAndCollectType">
                                <option value="" selected>Nessuna</option>
                                <option *ngFor="let obj of urlClickAndCollectTypeList" value="{{obj.value}}">
                                   {{obj.label}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <div class="mx-3">
                            <label for="field_documentId" class="form-label label-fw">Documento</label>
                            <ng-autocomplete #documentIds placeholder="Cerca Documenti" [data]="documentIds_Suggestion"
                                [searchKeyword]="documentIds_Keyword" (selected)='selectEvent__documentIds($event)'
                                (inputChanged)='getList_documentIds($event)'
                                (inputFocused)='onFocused__documentIds($event)'
                                (inputCleared)="searchCleared__documentIds()" [itemTemplate]="itemTemplate_documentIds"
                                [notFoundTemplate]="notFoundTemplate_documentIds" [debounceTime]="600"
                                [formControl]="initialDocumentValue" [isLoading]="documentIds_isKeywordLoadingResult" 
                                [minQueryLength]="2">
                            </ng-autocomplete>
                            <ng-template #itemTemplate_documentIds let-item>
                                <div class="col-12">
                                    <div class="mx-3">
                                        <span [innerHTML]="item.name"></span>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template #notFoundTemplate_documentIds let-notFound>
                                {{errorMsg_documentIds}}
                            </ng-template>
                        </div>
                    </div>
                </div>



                <!--Image-->
                <div class="row px-3 my-4 align-items-center">
                    <div class="col m-3">
                        <label for="exampleFormControlInput1" class="form-label label-fw">Immagine</label><br>
                        <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3"
                            (click)="openLoadImageFromPC()">
                            Carica da PC
                        </button>
                        <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3"
                            (click)="openLoadImageFromDAM()">
                            Carica da D.A.M.
                        </button>
                        <button type="button" class="btn btn-outline-warning btn-outline-fw text my-3"
                            (click)="deleteImage()">
                            Elimina
                        </button>

                        <div class="thumb-area d-flex justify-content-center my-3">
                            <div class="icona justify-content-center" [hidden]="visibleImageChoice">
                                <i class="fas fa-camera"></i>
                            </div>
                            <img [src]="imageChoice.url" alt="Anteprima" class="img-thumbnail img-thumbnail-dim"
                                [hidden]="!visibleImageChoice">
                        </div>

                        <input type="text" formControlName="iconId" name="iconId" hidden>
                    </div>
                </div>


            </form>




            <!--Buttons-->
            <div class="row">
                <div class="col-12">
                    <div class="my-4 text-center">
                        <button type="button" class="btn btn-fw text me-3" (click)="clickButtonSave()">Salva
                            modifiche</button>
                        <button type="button" class="btn btn-outline-warning btn-outline-fw text"
                            (click)="clickButtonCancel()">Annulla</button>
                    </div>
                </div>
            </div>



        </div>
    </div>
</div>